// extracted by mini-css-extract-plugin
export default {"collaborationButtonContainer":"collaboration_collaborationButtonContainer__TPVd9","collaborationCenterContainer":"collaboration_collaborationCenterContainer__oTHul"};